<template>
  <div v-if="alert_model">
<!--    version of the alert that would work for multiple alerts. (I think? Untested)-->
  <!--<v-alert v-for="alert_value in alert_values" :key="alert_value.alert_model" dismissible :color="alert_values.alert_color" :icon="alert_values.alert_icon" v-model="alert_values.alert_model"
           transition="scale-transition">{{alert_values.alert_message}}</v-alert>-->
    <v-alert dismissible :color="alert_color" :icon="alert_icon" v-model="alert_model"
             transition="scale-transition" style="z-index: 1">{{alert_message}}</v-alert>
  </div>
</template>

<script>
// TODO figure out what's causing the error with the onlogout from App, and the error from sending data
// to the alert, getting this error: 'uncaught exception: Object'
export default {
  name: 'Alert',
  data() {
    return {
      alert_values: [
      ],
      alert_color: '',
      alert_icon: '',
      alert_model: false,
      alert_message: '',
    };
  },


};
</script>

<style scoped>

</style>
